import { useResources } from "../../hooks/useResources";
import ContentHeader from "../contentHeader/ContentHeader";

interface SectionDetailsInfoProps {
  title: string;
  country: string;
  language: string;
  grade: string;
  subject: string;
  term: string;
}

const SectionDetailsInfo = ({
  title,
  country,
  language,
  grade,
  subject,
  term,
}: SectionDetailsInfoProps) => {
  const { getResourceValue } = useResources();

  return (
    <div className="job-details__info-section">
      <div className="job-details__info-container">
        <ContentHeader
          title={getResourceValue("section_details", "Section Details")}
          headingLevel={2}
          showActions={false}
          className="content-header--section-title"
        />
        <div className="job-details__info-grid">
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("title", "Title")}
            </span>
            <span className="job-details__info-value">{title}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("country", "Country")}
            </span>
            <span className="job-details__info-value">{country}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("language", "Language")}
            </span>
            <span className="job-details__info-value">{language}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("grade", "Grade")}
            </span>
            <span className="job-details__info-value">{getResourceValue(grade)}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("subject", "Subject")}
            </span>
            <span className="job-details__info-value">{subject}</span>
          </div>
          <div className="job-details__info-item">
            <span className="job-details__info-label">
              {getResourceValue("term", "Term")}
            </span>
            <span className="job-details__info-value">{term}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionDetailsInfo;

